import { prompt, type PromptDefinition } from './models';

export const PROPERTY_MANAGER_PROMPTS = [
    prompt(
        'Assess value & use',
        'What tenant or occupant issues are recorded for this building?',
        'Which buildings have unresolved tenant or occupant issues?'
    ),
    prompt(
        'Keep it running',
        'Which reported repairs in this building still need follow-up?',
        'Which buildings have the longest-standing reported repairs to follow up?'
    ),
    prompt(
        'Coordinate people',
        "Who is responsible for the next actions on this building's recorded issues?",
        'Where are issue responsibilities unclear across my buildings?'
    ),
    prompt(
        'Coordinate people',
        'Find property-management correspondence for this building about…',
        'Find property-management correspondence across my buildings about…',
        'prefill'
    ),
    prompt(
        'Assess value & use',
        'What lease obligations for this building are documented as due soon?',
        'Which buildings have upcoming lease obligations needing coordination?'
    ),
    prompt(
        'Keep it running',
        'What evidence shows contractors completed the repairs at this building?',
        'Which buildings have repairs marked complete without supporting contractor records?'
    ),
    prompt(
        'Meet obligations',
        "Which compliance records should I include in this building's owner update?",
        'Which buildings need compliance exceptions highlighted in owner updates?'
    ),
    prompt(
        'Coordinate people',
        'Find tenant communications for this building concerning…',
        'Find tenant communications across my buildings concerning…',
        'prefill'
    ),
    prompt(
        'Assess value & use',
        "What do the records say about access arrangements for this building's contractors?",
        'Which buildings have missing contractor access information?'
    ),
    prompt(
        'Coordinate people',
        "Which owner or tenant approvals are still outstanding for this building's work?",
        'Which buildings have work awaiting documented owner or tenant approval?'
    ),
    prompt(
        'Understand it',
        "Summarise this building's open management matters using the available records.",
        "Which buildings should I prioritise in this week's property-management review?"
    ),
    prompt(
        'Coordinate people',
        'Prepare an owner-update draft for this building focused on…',
        'Prepare a property-management update across my buildings focused on…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
